import DashboardLayout from "@/packages/dashboard/modules/dashboard/views/dashboardLayout";
import Exams from "@/packages/exams/view/exam";
import RemarkList from "../Remark/components/RemarkList";
import RemarkCard from "../Remark/components/RemarkCard";
import RemarkPayments from "../Remark/components/RemarkPayments";
import RemarkReceipt from "../Remark/components/RemarkReceipt";
import Auth from "@/packages/dashboard/modules/auth/middleware/Auth";
import ProfileComplete from "@/packages/dashboard/modules/auth/middleware/ProfileComplete";

export default [
  {
    path: "/exams",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "Exams",
        component: Exams,
        children: [
          {
            path: "remark",
            name: "Remark",
            component: RemarkList,
            middleware: [Auth, ProfileComplete],
          },
        ],
      },
      {
        path: "",
        name: "Exams",
        component: Exams,
        children: [
          {
            path: "RemarkCard/:code?",
            name: "RemarkCard",
            component: RemarkCard,
            middleware: [Auth, ProfileComplete],
          },
        ],
      },
      {
        path: "",
        name: "Exams",
        component: Exams,
        children: [
          {
            path: "RemarkPayments/:code?",
            name: "RemarkPayments",
            component: RemarkPayments,
            middleware: [Auth, ProfileComplete],
          },
        ],
      },
      {
        path: "",
        name: "Exams",
        component: Exams,
        children: [
          {
            path: "RemarkReceipt/:code?",
            name: "RemarkReceipt",
            component: RemarkReceipt,
            middleware: [Auth, ProfileComplete],
          },
        ],
      },
    ],
  },
];
